import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    feVersion: '2.1.0',
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
